import type { SourceFilterAdapter } from './types';
import { getSourceModule } from '../sourceModules';

export function getSourceFilterAdapter(source: string): SourceFilterAdapter | undefined {
  return getSourceModule(source)?.filters?.adapter;
}

export { avitoFilterAdapter } from '../avito/filterAdapter';
export type { SearchApiParams, SearchQuery, SourceFilterAdapter } from './types';
